@use "~@nwi/style-core/variables/color" as *;

@use "styles/themes" as *;

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  .slider-window {
    position: relative;
    width: 100%;
    margin-top: -16px;
    overflow: hidden;
  }

  .slides-container {
    display: flex;
    overflow: hidden;
    transition: transform 0.3s ease-out;
    will-change: transform;

    &:not(.no-grab) {
      cursor: grab;
    }
  }

  .prev,
  .next {
    position: absolute;
    top: 50%;
    width: auto;
    height: auto;
    font-weight: bold;
    transform: translateY(-50%);
    cursor: pointer;
    user-select: none;
    padding: 40px;
  }

  .next {
    position: absolute;
    right: 0;
  }

  .slide-wrapper {
    overflow: hidden;
  }

  .slide {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0;
    padding-bottom: 56.26%;

    fading-image.slider-image >img,
    img.slider-image {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      object-fit: cover;
      transition: transform 0.3s ease-in-out;
      user-select: none;
    }

    img.fallback {
      width: 100%;
      padding: 10%;
    }
  }

  #nwi-root.no-footer {
    .slide-wrapper {
      padding-bottom: 0;
    }
  }

  .slider-footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--footer-height);
  }

  .no-transition {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
  }

  .grabbing {
    cursor: grabbing;
  }

  /* .grabbing .slide img {
    transform: scale(0.9);
  } */

  #nwi-root {
    &:not(.MD) {
      --footer-height: 20px;

      .prev,
      .next {
        display: none;
      }
    }
  }
}
